// extracted by mini-css-extract-plugin
export var content = "StrapiQuoteAndImage-module--content--07733";
export var image = "StrapiQuoteAndImage-module--image--e018c";
export var innercontent = "StrapiQuoteAndImage-module--innercontent--0ec32";
export var media = "StrapiQuoteAndImage-module--media--ef3af";
export var root = "StrapiQuoteAndImage-module--root--547e8";
export var video = "StrapiQuoteAndImage-module--video--28d69";